import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { payInvoiceRequested } from '../services/document-helper.service';
import { getJobCustomerUser } from '../utilities/job-customer.util';

import { CreateTransactionDialogActions } from './create-transaction-dialog/create-transaction-dialog.actions';

export const openCreateTransactionDialogForInvoice = createEffect((
  actions$ = inject(Actions),
) => {
  return actions$.pipe(
    ofType(payInvoiceRequested),
    map(({ invoice, defaultAmount }) =>
      CreateTransactionDialogActions.invoicePayButtonClicked({
        jobId: invoice.job.id,
        customerId: getJobCustomerUser(invoice.job.users)?.id,
        currency: invoice.currency,
        invoiceId: invoice.id,
        amountMinor: defaultAmount,
      })),
  );
}, { functional: true, dispatch: true });
